var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('event-registry-versions-widget',{attrs:{"contractId":_vm.contractId},on:{"clickedOnVersion":_vm.openVersion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }